import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {

  constructor(
  	private navBar:NavBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService
	) { }

  handler(evt){
  	switch(evt){
  		case 'menu':{
  			this.menuService.goto('lock_widget')
        return;
  		}
	  	case 'back':{
	  		this.navBar.disableAll();
	  		this.menuService.goto('dashboard');
        return;
	  	}
	  	default:{
	  		return;
	  	}
  	}
  }
  subscription:any=undefined;
  ngOnDestroy(){
  	if(this.subscription){
  		this.subscription.unsubscribe();
  	}
  }
  offset=4;
  number='';
  contact(){
    /*if(this.number.length <= 4){
      return this.number;
    }else{*/
      let n = '    '+this.number+'    ';
      if(this.offset+4>=n.length){
        this.offset = 0;
      }
      return n.substr(this.offset,4);
    //}
  }
  _scrollHandle=undefined;

  startScrolling(){
    this._scrollHandle = setInterval(
      ()=>{
        this.offset++;
      },
      1000);
  }
  stopScrolling(){
    clearInterval(this._scrollHandle);
    this._scrollHandle = undefined;
  }

  ngOnInit() {
    this.number = this.ioService.getContactPhone();
    //if(this.number.length > 4){

      this.startScrolling();
    //}

  	this.navBar.enableAll();
  	this.navBar.blink('mobile');
  	this.subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
  		this.handler(evt);
  	});
  }
}

